import script from "./ShareDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDialog.vue?vue&type=script&setup=true&lang=js"

import "./ShareDialog.vue?vue&type=style&index=0&id=03655884&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03655884"]])

export default __exports__